/**
 * Columns for the Purchase Orders drill-down (`openPOModal`). Nothing on the
 * table opens it today; kept so the modal renders every type through the same
 * table + export path.
 */
import { Badge } from '../../../components/ui/badge';
import { CUSTOMER_REQUIRED_DATE } from '../../../config/dateLabels';
import PoHeaderLink from '../../../components/common/PoHeaderLink';
import { PurchaseOrder } from '../../../lib/api';
import { DrilldownColumn, DrilldownFormatters, dateOf } from './columns';

export function poColumns(f: DrilldownFormatters): DrilldownColumn<PurchaseOrder>[] {
  return [
    {
      key: 'po_number', label: 'PO Number', className: 'font-medium',
      value: (po) => po.po_number,
      render: (po) => <PoHeaderLink poNumber={po.po_number}>{po.po_number}</PoHeaderLink>,
    },
    {
      key: 'status', label: 'Status', align: 'center',
      value: (po) => po.status,
      render: (po) => <Badge>{po.status}</Badge>,
    },
    { key: 'delivery_date', label: CUSTOMER_REQUIRED_DATE, value: (po) => dateOf(f.formatDate, po.customer_required_date) },
    { key: 'total_value', label: 'Total Value', kind: 'money', align: 'right', value: (po) => po.total_value ?? null },
    { key: 'line_count', label: 'Line Items', kind: 'qty', align: 'right', value: (po) => po.line_count ?? null },
  ];
}
